











import {
  defineNuxtComponent,
  ref,
  vue3Model,
  watch,
  computed
} from '~/utils/nuxt3-migration'
import CFormGroup from '~/components/shared/configurable/form/CFormGroup.vue'
import CInputAutocomplete from '~/components/shared/configurable/form/input/CInputAutocomplete.vue'
import { AutocompleteSuggestion } from '~/models/autocomplete'
import { LocationSuggestion } from '~/models/location/autocomplete/types'
import LocationSuggestionService from '~/services/location/autocomplete/LocationSuggestionService'
import { useDeps } from '~/compositions/dependency-container'

export default defineNuxtComponent({
  model: vue3Model,
  components: {
    CFormGroup,
    CInputAutocomplete
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  setup(props, { emit }) {
    const [locationSuggestionService] = useDeps(LocationSuggestionService)

    const facet = ref(props.modelValue)
    const locations = ref<Map<string, LocationSuggestion>>(new Map())
    const selectedLocationName = ref(
      getSelectedLocationName(facet.value.values.valuesTree[0])
    )

    const locationSuggestions = computed<AutocompleteSuggestion[]>(() =>
      [...locations.value.values()].map(v => ({
        id: v.id,
        name: v.name,
        subText: v.area
      }))
    )

    watch(
      () => props.modelValue,
      newValue => {
        facet.value = {
          ...facet.value,
          ...newValue
        }
      }
    )

    function onSelectSuggestion(suggestion: AutocompleteSuggestion) {
      emit('update:modelValue', {
        name: facet.value.urlargNames[0],
        value: suggestion.id
      })
    }

    async function onRequestSuggestions(query: string) {
      locations.value = await locationSuggestionService.getLocations(query)
    }

    function getSelectedLocationName(value: any): string {
      if (!value) {
        return ''
      }

      return value.children?.length
        ? getSelectedLocationName(value.children[0])
        : value.name
    }

    return {
      facet,
      locationSuggestions,
      selectedLocationName,
      onSelectSuggestion,
      onRequestSuggestions
    }
  }
})
